export var getNameFromCode = function getNameFromCode(code) {
  return STATES[code.toUpperCase()];
};
export var getCodeFromFullAddress = function getCodeFromFullAddress(fullAddress) {
  // 123 Main St, Apt 12, Orlando, FL 32801
  var addressParts = fullAddress.trim().split(' ');
  addressParts.pop(); // Zip code
  return addressParts.pop(); // State code
};

export var getNameFromFullAddress = function getNameFromFullAddress(fullAddress) {
  return getNameFromCode(getCodeFromFullAddress(fullAddress));
};
export var getStates = function getStates(code) {
  return Object.keys(STATES).map(function (code) {
    return {
      code: code,
      name: STATES[code]
    };
  });
};
var STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};